import React from 'react';
import type { LogoMakerIntegration } from '../../context/LogoMakerContext';
import LogoMakerProviders from '../../context/LogoMakerContext/LogoMakerProviders';
import { LoggedOutLogoMakerBase } from '../LoggedOutLogoMaker/LoggedOutLogoMakerBase';

export interface LoggedOutLogoMakerLPProps {
    showBackButton?: boolean;
    integration?: LogoMakerIntegration;
}

export const LoggedOutLogoMakerLP = ({ showBackButton, integration }: LoggedOutLogoMakerLPProps = {}) => (
    <LogoMakerProviders isSticky isTransparent showBackButton={showBackButton} integration={integration}>
        <LoggedOutLogoMakerBase showSeoLinks showJoinLink />
    </LogoMakerProviders>
);

export default LoggedOutLogoMakerLP;
